import { Col, Row } from 'antd';

import FormCheckBox from '@/views/components/Inputs/FormCheckBox';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import FormTextArea from '@/views/components/Inputs/FormTextArea';

import TrailerDrawer from './TrailerDrawer';

const TrailerIssueForm = ({
  issueHidden,
  CloseIssueModal,
  formIssueTrailer,
  trailerNumberOptions,
  onTrailerIdSelectGetIssue,
  isOutOfService,
  handleChange,
  onTrailerNoteInput,
  handleUpdateTrailerNote,
}) => {
  return (
    <TrailerDrawer
      openTrailerDrawer={issueHidden}
      closeTrailerDrawer={CloseIssueModal}
      trailerForm={formIssueTrailer}
      drawerHeader="Issue to Report"
    >
      <Row gutter={20}>
        <Col sm={12}>
          <FormSelectBox
            label="Trailer #"
            editMode
            name="IssueTrailerNumber"
            margin="m-0"
            options={trailerNumberOptions}
            onChange={onTrailerIdSelectGetIssue}
          />
        </Col>
        <Col sm={12} className="d-flex align-items-end">
          <FormCheckBox
            checkBoxClass="normal-checkbox"
            label="DO NOT USE"
            name="notused"
            checked={isOutOfService}
            className="mt-24"
            onChange={handleChange}
          />
        </Col>
        <Col sm={12}>
          <FormTextArea
            editMode
            name="issuetoReport"
            margin="mb-14"
            label="Issue to Report"
            placeholder="Issue to Report"
            enableAutoFocus={false}
            rows={3}
            onChange={onTrailerNoteInput}
          />
        </Col>
      </Row>

      <Row gutter={20}>
        <Col sm={24} className="text-center mt-5">
          <button type="button" className="btn btn-dipblue" onClick={handleUpdateTrailerNote}>
            {' '}
            Submit Report{' '}
          </button>
        </Col>
      </Row>
    </TrailerDrawer>
  );
};

export default TrailerIssueForm;
